import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { gpsSelector } from '../../selectors/gps';
import { submitGpsBatchRequest, 
    submitGpsDevicesValidateBatchRequest, 
    setStateGps, 
    clearValidatedGpsDevices, 
    unsubscribeRequest,
    cleanUnsubscribe
 } from '../../actions/gps';
import CreateGps from './CreateGps';

const mapStateToProps = createStructuredSelector({
    gps: gpsSelector
});
const mapDispatchToProps = {
    submitGpsBatchRequest,
    submitGpsDevicesValidateBatchRequest,
    setStateGps,
    clearValidatedGpsDevices,
    unsubscribeRequest,
    cleanUnsubscribe
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateGps);